import { styled } from '@mui/material/styles';
import { css, TextareaAutosize } from '@mui/material';
import { themeColors } from '@ianesthesie-kit/config';
import { Property } from 'csstype';

export const Textarea = styled(TextareaAutosize)<{ resize?: Property.Resize }>`
  width: 100%;
  max-width: 100%;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
  color: ${themeColors.gray[900]};
  border: 1px solid ${themeColors.gray[200]};
  box-shadow: 0px 2px 2px ${themeColors.gray[50]};

  ${(props) =>
    !!props.resize &&
    css`
      resize: ${props.resize};
    `}

  &:hover {
    border-color: ${themeColors.indigo[400]};
  }

  &:focus {
    border-color: ${themeColors.indigo[400]};
    box-shadow: 0 0 0 3px ${themeColors.indigo[200]};
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`;
